import FeaturedSolutions from "../../../components/FeaturedSolutions";
import HorizontalLine from "../../../components/icons/HorizontalLine";
import LogoMini from "../../../components/icons/LogoMini";
import InfoGenesis from "../../../assets/img/Featured/tablet-info-genesis.png";
import IGKiosk from "../../../assets/img/Featured/kiosk-food-order.png";
import DigitalMenu from "../../../assets/img/Featured/digital-menu.png";
import "./index.scss";
import { useNavigate } from "react-router-dom";
import { useAnalytics } from "@popped/popshap-kiosk-components";
import { useData } from "../../../context/DataProvider";
import { useCallback } from "react";
import { Header } from "../../../components/Header";

const EmployeeDiningPage = () => {
    const { logEvent } = useAnalytics();
    const { addFlow, location } = useData()!;
    const _logEvent = useCallback(async (type: string, value: string, id?: string) => {
        await logEvent(type, value, { kiosk: location, id: id })
    }, [logEvent,location])
    const navigate = useNavigate();
    return(
        <div className="page employeeDiningPage">
            <Header />
            <div className="page-header">On Site Dining</div>
            <div className="text-wrapper">
                <div className="top">
                    <div className="topic-header">Employee Dining</div>
                    <HorizontalLine />
                </div>
                <div className="std-text">
                    In casual dining environments speed matters
                    most. IG Digital Menu Boards offer simple,
                    highly visible views of menus and promotions,
                    while Agilysys InfoGenesis POS and IG Kiosk
                    provide diners with the convenient self-service
                    ordering and quick payment options. The result is
                    fast, accurate and on-time food delivery to keep
                    service moving.
                </div>
            </div>

            <FeaturedSolutions>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Employee Dining", "InfoGenesis");
                    addFlow("InfoGenesis");
                    navigate("/solutions/info-genesis")}}>
                    <div className="item-head">
                        <LogoMini />
                        InfoGenesis
                    </div>
                    <img src={InfoGenesis} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Employee Dining", "IG Kiosk");
                    addFlow("IG Kiosk");
                    navigate("/solutions/ig-kiosk")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Kiosk
                    </div>
                    <img src={IGKiosk} alt="" />
                </div>
                <div className="featured-item" onClick={()=>{
                    _logEvent('click', "Dining - Employee Dining", "IG Digital Menu Board");
                    addFlow("IG Digital Menu Board");
                    navigate("/solutions/digital-menu")}}>
                    <div className="item-head">
                        <LogoMini />
                        IG Digital Menu Board
                    </div>
                    <img src={DigitalMenu} alt="" />
                </div>
            </FeaturedSolutions>
        </div>
    )
}
export default EmployeeDiningPage;